// extracted by mini-css-extract-plugin
export default {"wrap":"VideoDetail_wrap__Wculq"};